import axios from 'axios';
import React, { createContext, useEffect, useState } from 'react';

const apiValue = createContext();

function AllData({ children }) {
  const [api, setApi] = useState([]);
  useEffect(() => {
    axios.get('/assets/js/api.json').then((respone) => {
      setApi(respone.data)
    })
  }, [])
  return (
    <apiValue.Provider value={api} >
      {children}
    </apiValue.Provider >
  )
}

export { AllData, apiValue }